"use client";
import { Check } from "lucide-react";
import StepMarker from "../StepMarker";
import { Button } from "../Button";

export default function Step3EventNeeds({
  formData,
  eventNeeds,
  updateFormData,
  onBack,
  onNext,
  onSkip,
}) {
  const toggleNeed = (need) => {
    const updatedNeeds = formData.needs.includes(need)
      ? formData.needs.filter((n) => n !== need)
      : [...formData.needs, need];

    updateFormData({ needs: updatedNeeds });
  };

  const isSelected = (need) => formData.needs.includes(need);

  return (
    <div>
      <StepMarker currentStep={3} totalSteps={5} onBack={onBack} />

      <h2 className="text-2xl font-bold mb-1">What Does Your Event Need?</h2>
      <p className="text-gray-500 mb-6">Select all your event requirements</p>

      <div className="space-y-3">
        {eventNeeds && eventNeeds.length == 0 && (
          <div>
            <p className="text-gray-500 mb-6">
              No Event Needs Available for this type.
            </p>
          </div>
        )}
        {eventNeeds &&
          eventNeeds.map((need) => (
            <div
              key={need.id}
              onClick={() => toggleNeed(need.eventneedsname)}
              className={`flex items-center justify-between p-4 border rounded-lg cursor-pointer transition-colors ${
                isSelected(need.eventneedsname)
                  ? "border-green-500 bg-green-50"
                  : "hover:border-[#7B189F]"
              }`}
            >
              <div className="flex items-center">
                <span className=" mr-2">{need.image_url}</span>
                <div>
                  <h3 className="font-medium">{need.eventneedsname}</h3>
                  <p className="text-sm text-gray-500" />
                </div>
              </div>
              <div
                className={`w-6 h-6 flex items-center justify-center rounded-sm border ${
                  isSelected(need.eventneedsname)
                    ? "bg-green-500 border-green-500"
                    : "border-gray-300"
                }`}
              >
                {isSelected(need.eventneedsname) && (
                  <Check size={16} className="text-white" />
                )}
              </div>
            </div>
          ))}
      </div>

      <div className="flex justify-between mt-8">
        <Button variant="outline" onClick={onBack}>
          Back
        </Button>
        <div className="space-x-3">
          <Button
            onClick={onNext}
            className="bg-[#7B189F] hover:bg-[#671485] text-white"
          >
            {formData.needs.length === 0 ? "Skip Vendors" : "Continue"}
          </Button>
        </div>
      </div>
    </div>
  );
}
